/* ==========================================================
   REIKO — Scroll Reveal v1
   Install: Edit code > Assets > Add a new asset >
   create "reiko.js" > paste this.
   Then in layout/theme.liquid, add BEFORE </body>:
     <script src="{{ 'reiko.js' | asset_url }}" defer></script>
   What it does: every section fades and rises into view as
   you scroll — the "expensive site" feel. Zero dependencies.
   ========================================================== */
(function () {
  var targets = document.querySelectorAll(
    "main .shopify-section > *, .card-wrapper, .multicolumn-card"
  );
  if (!("IntersectionObserver" in window) || !targets.length) return;

  targets.forEach(function (el, i) {
    el.classList.add("rk-reveal");
    el.style.transitionDelay = Math.min(i % 4 * 90, 270) + "ms";
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("rk-in");
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
  );

  targets.forEach(function (el) { io.observe(el); });
})();